<template>
  <div class="qr-code">
    <img src="@/assets/images/QR-bg.png" class="background">
    <div class="content">
      <p class="title">识别二维码关注公众号</p>
      <img src="@/assets/images/mp.jpg">
    </div>
  </div>
</template>
<script>
export default {
  methods: {
  }
}
</script>
<style scoped lang="scss">
  .qr-code {
    min-height: 100vh;
    .background {
      width: 100%;
      height: 200px;
    }
    .content {
      min-height: 100%;
      margin-top: 25px;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        margin-top: 17.5px;
        width: 192px;
        border-radius: 10px;
        border: #4989E5 10px solid;
      }
      .title {
        letter-spacing: 3px;
        font-size: 15px;
        color: #005BAC;
      }
    }
  }
</style>
